import { trackEvent } from 'utils/analytics/track/trackEvent';

import { SetGMapsErrorAction } from './gMapsError';

export function setGMapsError(error: string): SetGMapsErrorAction {
  trackEvent('Google Maps API Error', {
    error,
  });
  return {
    type: 'SET_GMAPS_ERROR',
  };
}
